var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFooterMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 430,
    height: 76.186,
    viewBox: "0 0 430 76.186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 76.186,
    fill: "#040506"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.32,35.122a20.085,20.085,0,0,1,10.851,2.91q7.638,4.85,7.638,15.276A17.381,17.381,0,0,1,166.6,66.4a18.579,18.579,0,0,1-13.457,5.092H136.408V69.916h4.85V36.7h-4.85V35.122Zm-6.85,1.576V69.916h6.85a15.182,15.182,0,0,0,2.365-.181q10.3-1.576,10.3-16.67a28.28,28.28,0,0,0-.909-7.638Q162.716,36.7,153.139,36.7Z",
    transform: "translate(-64.652 -16.647)",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2,37.546q6.97,5.214,6.971,15.215A18.243,18.243,0,0,1,251.41,66.7a17.33,17.33,0,0,1-12.306,4.85,17.681,17.681,0,0,1-11.275-3.88Q221.1,62.339,221.1,52.518a17.9,17.9,0,0,1,18.186-18.549A17.6,17.6,0,0,1,250.2,37.546m-6.426,31.4q7.333-3.212,7.335-16.428-.061-16.73-12-16.852a13.718,13.718,0,0,0-3.213.364q-8.729,2.3-8.729,16.73a31.321,31.321,0,0,0,.849,7.7q2.485,9.4,11.275,9.4a11,11,0,0,0,4.486-.91",
    transform: "translate(-104.794 -16.1)",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.305,71.492a2.022,2.022,0,0,1-.909-.182q-.668-.364-1.758-3.455l-6.486-18.307-7.881,22.247h-.485a2.3,2.3,0,0,1-.728-.121q-.97-.364-2.182-3.819L303.724,36.7h-3.576V35.121h13.336V36.7h-4.91l10.244,28.491,6.365-18.428L321.06,35.121h10.426V36.7h-4.91l9.76,28.612L345.853,36.7H341V35.121h9.82V36.7h-3.031l-12,34.795Z",
    transform: "translate(-142.259 -16.646)",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.815,35.121h12.427V36.7h-4.85V71.189L434.6,71.8,410.781,41.85V69.916h3.576a3.129,3.129,0,0,1,.607.061c.645.12.969.627.969,1.515H403.507V69.916h4.85V36.7h-4.85V35.121h8.426l23.035,28.733V36.7h-5.152Z",
    transform: "translate(-191.248 -16.646)",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.013,71.492V69.916h5.759V36.7H497.5q-4.669.364-6.608,6.3l-.97,4.062h-1.7l.3-11.942h29.945l.3,11.942h-1.7L516.108,43a.834.834,0,0,1-.061-.364Q514.411,36.7,509.5,36.7h-3.516V69.916h4.122a3.169,3.169,0,0,1,.607.061q.968.182.969,1.516Z",
    transform: "translate(-231.4 -16.646)",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.489,37.546q6.97,5.214,6.971,15.215A18.243,18.243,0,0,1,591.7,66.7a17.33,17.33,0,0,1-12.306,4.85,17.681,17.681,0,0,1-11.275-3.88q-6.728-5.333-6.729-15.155a17.9,17.9,0,0,1,18.186-18.549,17.6,17.6,0,0,1,10.911,3.577m-6.426,31.4q7.333-3.212,7.334-16.428-.061-16.73-12-16.852a13.717,13.717,0,0,0-3.213.364q-8.729,2.3-8.729,16.73a31.318,31.318,0,0,0,.848,7.7q2.485,9.4,11.275,9.4a11,11,0,0,0,4.485-.91",
    transform: "translate(-266.079 -16.1)",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.6,71.492a2.022,2.022,0,0,1-.909-.182q-.668-.364-1.758-3.455l-6.486-18.307-7.881,22.247h-.485a2.3,2.3,0,0,1-.727-.121q-.97-.364-2.182-3.819L644.016,36.7h-3.576V35.121h13.336V36.7h-4.91l10.244,28.491,6.365-18.428-4.122-11.639h10.426V36.7h-4.91l9.76,28.612L686.145,36.7H681.3V35.121h9.82V36.7h-3.031l-12,34.795Z",
    transform: "translate(-303.545 -16.646)",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.107,35.121h12.427V36.7h-4.85V71.189L774.9,71.8,751.073,41.85V69.916h3.577a3.13,3.13,0,0,1,.607.061c.646.12.969.627.969,1.515H743.8V69.916h4.849V36.7H743.8V35.121h8.426L775.26,63.854V36.7h-5.152Z",
    transform: "translate(-352.534 -16.646)",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,0l-.378,76.186-37.9-38.453Z",
    transform: "translate(-22.947)",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,16.645,36.9,4.109,1.478,40.238,35.4,74.162,47.775,61.589l.405.4.347.342-.005.005L36.144,74.9l.005.005-.742.747L0,40.248,36.938,2.568,48.848,15.9Z",
    transform: "translate(0 -1.217)",
    fill: "#040506"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooterMobile);
export default __webpack_public_path__ + "static/media/logo-footer-mobile.6609520da184d53c403ec2af7a1f33eb.svg";
export { ForwardRef as ReactComponent };